import React from "react";

export const Logo = ({ className = "h-10 w-auto" }) => (
  <a
    href="/"
    className={`flex items-center ${className}`}
    data-testid="nx-logo"
    aria-label="Nexodiag — retour à l'accueil"
  >
    <img
      src="https://customer-assets.emergentagent.com/job_nexo-branding/artifacts/wsb9tnpk_logonex2.png"
      alt="Nexodiag — Fiabilité · Réactivité · Performance"
      className="h-12 md:h-14 w-auto object-contain"
      draggable={false}
    />
  </a>
);

export default Logo;
